import { useMutation } from 'react-query';
import { ocrService } from '../../services';
import { enqueueSnackbar } from '../../design-system';
import { MESSAGES } from '../../const';

export const useGetContainerOcrMutation = () => {
  return useMutation((file: any) => ocrService.getContainer(file), {
    onSuccess: ({ data }) => {
      if (Object.values(data).join('').length === 0) {
        enqueueSnackbar(MESSAGES.OCR.NOT_FOUND, 'error');
      }
    },
    onError: () => enqueueSnackbar(MESSAGES.OCR.SERVER_OFF, 'error'),
  });
};
